export default "__VITE_ASSET__B2O_9sjA__"